export enum OwnershipMode {
  BeneficialOwnersRegister = 'Beneficial Owners Register',
  CompanyRegister = 'Company Register',
}
